import { z } from 'zod';

/**
 * The wizard route's search params (issue #16), both optional so that every
 * existing navigation to `/wizard/$matrixId` stays valid without a `search`.
 *
 * - `derivedFrom`: the source matrix when the draft was created with
 *   « Nouvelle matrice depuis celle-ci » — step 1 shows the pre-filled banner.
 * - `pivotReset`: the source pivot was blank for a step and the draft fell
 *   back to Levier de valeur — step 1 explains it.
 *
 * A malformed value is dropped rather than failing the route: these only
 * steer an information banner, never what the wizard edits.
 */
export const wizardSearchSchema = z.object({
  derivedFrom: z.string().uuid().optional().catch(undefined),
  pivotReset: z.boolean().optional().catch(undefined),
});
export type WizardSearch = z.infer<typeof wizardSearchSchema>;
